import { FC, ReactNode } from 'react'

import { useAccountReadContext } from '@context/AccountContextContext'

import { RichIcon } from '@ui/components/RichIcon'
import { ArrowCircleIcon } from '@ui/icons/ArrowCircle.icon'
import { ArrowCircleLeftRightIcon } from '@ui/icons/ArrowCircleLeftRight.icon'

import { TransactionType, isTransactionPositive } from '@utils/transaction.utils'

import { TransactionDto } from '@model/TransactionDto'

export const TransactionTypeIcon: FC<{
  transaction: TransactionDto
  variant?: 'default' | 'neutral'
}> = ({ transaction, variant = 'default' }): ReactNode => {
  const { account } = useAccountReadContext()

  const isNeutral = variant === 'neutral'
  const iconColor = isNeutral ? 'text-low-em' : 'text-white'
  const neutralBg = 'surface-white-smoke-0'
  const isPositive = isTransactionPositive(transaction, account?.id)
  if (DEPOSIT_TRANSACTION_TYPES.includes(transaction.type.id) && isPositive) {
    return (
      <RichIcon
        size='x40'
        shape='circle'
        icon={{ icon: ArrowCircleIcon.Down, color: iconColor }}
        bg={isNeutral ? neutralBg : 'surface-success-high-em'}
        border={isNeutral ? 'outline-low-em' : undefined}
      />
    )
  }
  if (WITHDRAWAL_TRANSACTION_TYPES.includes(transaction.type.id) && !isPositive) {
    return (
      <RichIcon
        size='x40'
        shape='circle'
        bg={isNeutral ? neutralBg : 'surface-disabled-med-em'}
        icon={{ icon: ArrowCircleIcon.Up, color: iconColor }}
        border={isNeutral ? 'outline-low-em' : undefined}
      />
    )
  }
  return (
    <RichIcon
      size='x40'
      shape='circle'
      bg={isNeutral ? neutralBg : 'surface-info-p-high-em'}
      icon={{ icon: ArrowCircleLeftRightIcon, color: iconColor }}
      border={isNeutral ? 'outline-low-em' : undefined}
    />
  )
}

export const DEPOSIT_TRANSACTION_TYPES: TransactionType[] = [
  TransactionType.IBCommission,
  TransactionType.LoyaltyRewardPayout,
  TransactionType.MIBCommission,
  TransactionType.MonthlyInterestTransfer,
  TransactionType.MultiTierIBCommission,
  TransactionType.WalletDeposit,
  TransactionType.IBRebate,
  TransactionType.Reverse,
]

export const WITHDRAWAL_TRANSACTION_TYPES: TransactionType[] = [
  TransactionType.WalletWithdrawal,
  TransactionType.Reverse,
  TransactionType.IBRebate,
  TransactionType.WithdrawToPaymentAgent,
]
